import { useEffect, useRef } from 'react'
export function usePrevious(value, condition) {
  const ref = useRef()
  useEffect(() => {
    if (condition) {
      ref.current = value
    }
  }, [value])
  return ref.current
}
